import { render, staticRenderFns } from "./TalkBasicAskOpinion.vue?vue&type=template&id=a9e35ae2&scoped=true&"
import script from "./TalkBasicAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./TalkBasicAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBasicAskOpinion.vue?vue&type=style&index=0&id=a9e35ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e35ae2",
  null
  
)

export default component.exports